import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from '../constants';
import agentKbRootDoc from './agentKbRootDoc';

const converter = {
  toFirestore(item: AgentKb.Pin): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): AgentKb.Pin {
    return {
      ...(snapshot.data(options) as AgentKb.Pin),
      id: snapshot.id,
    };
  },
};

// Canary pins: agentKb/main/pins/{scope}__{targetId}. The runtime reads these
// before the live pointer (user pin > account pin > pointer), which is what
// makes a published version inert until someone opts into it.
const getAgentKbPinsRef = ({
  scope,
  accountId,
  db,
}: {
  scope: AgentKb.ScopeName;
  accountId?: string;
  db?: firebase.firestore.Firestore;
}) =>
  agentKbRootDoc({ scope, accountId, db })
    .collection(STORE_CONSTANTS.AGENT_KB_PINS_COLLECTION)
    .withConverter(converter);

export default getAgentKbPinsRef;
